import { StyleSheet } from 'react-native'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
    container: {
        flexGrow: 1,
    },
    button: {
        marginTop: 32,
        marginHorizontal: 15,
    },
    headerStyle: {
        backgroundColor: 'transparent',
        borderBottomColor: 'transparent',
        marginTop: 10
    },
    offersContainer: theme => ({
        backgroundColor: theme.colors.backgroundColor,
        marginTop: 170,
        flex: 1,
        position: 'relative',
    }),
    countdownCard: theme => ({
        backgroundColor: theme.colors.cardBackgroundColor,
        minHeight: 100,
        position: 'absolute',
        top: -60,
        left: 16,
        right: 16,
        elevation: 2,
        shadowColor: 'rgba(0, 0, 0, 0.16)',
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowRadius: 4,
        shadowOpacity: 1,
        borderRadius: 6,
    }),
    offersTitleContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: 70,
        paddingHorizontal: 16,
    },
    infoButton: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    infoIcon: {
        marginLeft: 5,
    },
    line: {
        marginVertical: 15,
        marginHorizontal: 16,
    },
    flatlistContainer: {
        paddingBottom: 50,
        paddingHorizontal: 16,
    },
    card: theme => ({
        backgroundColor: theme.colors.cardBackgroundColor,
        elevation: 2,
        shadowColor: 'rgba(0, 0, 0, 0.16)',
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowRadius: 4,
        shadowOpacity: 1,
        borderRadius: 6,
        marginVertical: 5,
    }),
    itemContent: {
        flexDirection: 'row',
        padding: 20,
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    itemInfo: {
        flexDirection: 'row',
        flexShrink: 1
    },
    itemImage: {
        marginRight: 10,
    },
    textContainer: {
        width: '75%'
    },
    loaderContainer: {
        flex: 1,
        backgroundColor: Colors.white,
        borderRadius: 6,
        justifyContent: 'center',
        overflow: 'hidden',
        margin: 5
    },
})

export default styles
